import { Box, Heading, Container, Text, Button, Stack } from "@chakra-ui/react";
import MapGrid from "../components/MapGrid";
import Navbar from "../components/Navbar";

export default function Donate() {
  return (
    <Box>
      <Navbar />
      <MapGrid />
    </Box>
  );
}
